import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17.61 13.307l-2.726-2.726c-.503-.504-1.382-.503-1.884-.001l-1.482 1.482c-.046.046-.12.054-.167.017a21.626 21.626 0 0 1-2.078-1.826L7.748 8.728A21.785 21.785 0 0 1 5.92 6.649c-.036-.047-.028-.121.018-.167L7.42 5a1.334 1.334 0 0 0 0-1.884L4.694.391c-.503-.504-1.381-.504-1.885 0L.816 2.385a2.82 2.82 0 0 0-.535 3.21c1.879 3.924 5.047 6.857 5.145 6.944.123.134 3.056 3.3 6.979 5.18.393.188.814.28 1.23.28.729 0 1.446-.281 1.98-.815l1.993-1.993A1.32 1.32 0 0 0 18 14.25c0-.356-.138-.691-.39-.943z" />
  </svg>
);

export default SvgComponent;
